<template>
  <div class="realtimestatus">
    <v-container>
      <v-row>
        <v-col class="pb-0">
          <v-autocomplete
            dense
            label="Search People or Assets"
            solo
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <div class="floor-plan-box">
            <div class="groud">
              <img
                class="floor-plan"
                src="../assets/active-telematics-floor-plan.png"
              />
              <!-- room 1 marker -->
              <img id="marker-present-room1" src="../assets/green.jpg" />
              <!-- room 2 marker -->
              <img id="marker-present-room2" src="../assets/green.jpg" />
              <!-- room 3 marker -->
              <img id="marker-present-room3" src="../assets/green.jpg" />
              <!-- room 4 marker -->
              <img id="marker-present-room4" src="../assets/green.jpg" />
              <!-- room 5 marker -->
              <img id="marker-present-room5" src="../assets/green.jpg" />
              <!-- meeting room marker -->
              <img id="marker-present-meeting-room" src="../assets/green.jpg" />
              <!-- control room marker -->
              <img id="marker-present-control-room" src="../assets/green.jpg" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Room</th>
                  <th class="text-left">How Many People</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(loc, index) in mapLocLocal" :key="index">
                  <td>{{ loc.room }}</td>
                  <td>{{ loc.number }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-chip color="green" text-color="white">
            <v-avatar left>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            Present: {{ this.totalPresent }}
          </v-chip>
          <v-chip class="ml-2" dark text-color="white">
            <v-avatar left>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            Absent: {{ this.totalAbsent }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(bl, index) in realTimeLocal" :key="index">
          <v-card
            :color="bl.presence === 1 ? 'blue' : 'grey'"
            dark
            max-width="210"
          >
            <v-card-actions class="pb-0">
              <v-list-item class="grow pl-3">
                <v-list-item-avatar color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    alt=""
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    <p class="mb-0">{{ bl.name }}</p>
                    <p class="mb-0 white--text caption">{{ bl.braceletMac }}</p>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-actions>

            <v-card-text class="pt-0">
              <v-row>
                <v-col class="pb-0">
                  <v-chip :color="bl.presence === 1 ? 'green' : ''">
                    <v-avatar left>
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar>
                    Present</v-chip
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left>
                      <v-icon>mdi-location-enter</v-icon>
                    </v-avatar>
                    Entry
                    <span v-if="bl.presence === 1">
                      {{ ": " + new Date(bl.entry).toLocaleTimeString() }}</span
                    >
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left>
                      <v-icon> mdi-location-exit</v-icon></v-avatar
                    >
                    Absent
                    <span v-if="bl.presence === 0">{{
                      ": " + new Date(bl.lastentry).toLocaleTimeString()
                    }}</span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left>
                      <v-icon>mdi-cards-heart</v-icon>
                    </v-avatar>
                    Heart Rate
                    <span v-if="bl.presence === 1">{{ ": " + bl.HR }}</span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left>
                      <v-icon>mdi-temperature-celsius</v-icon>
                    </v-avatar>
                    Body Temp
                    <span v-if="bl.presence === 1">{{ ": " + bl.Temp }}</span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left>
                      <v-icon>mdi-shoe-print</v-icon>
                    </v-avatar>
                    Steps
                    <span v-if="bl.presence === 1">{{ ": " + bl.Step }}</span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-chip>
                    <v-avatar left> <v-icon>mdi-map-marker</v-icon> </v-avatar
                    >Loc
                    <span v-if="bl.presence === 1">{{ ": " + bl.Loc }}</span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">ID</th>
                  <th class="text-left">Present</th>
                  <th class="text-left">Entry</th>
                  <th class="text-left">Absent</th>
                  <th class="text-left">Heart Rate</th>
                  <th class="text-left">Body Temp</th>
                  <th class="text-left">Steps</th>
                  <th class="text-left">Loc</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(bl, index) in realTimeLocal" :key="index">
                  <td>{{ bl.name }}</td>
                  <td>{{ bl.braceletMac }}</td>
                  <td>
                    <v-icon :color="bl.presence === 1 ? 'green' : 'grey'"
                      >mdi-circle</v-icon
                    >
                  </td>
                  <td v-if="bl.presence === 1">
                    {{ new Date(bl.entry).toLocaleTimeString() }}
                  </td>
                  <td v-else-if="bl.presence === 0"></td>
                  <td v-if="bl.presence === 0">
                    {{ new Date(bl.lastentry).toLocaleTimeString() }}
                  </td>
                  <td v-else-if="bl.presence === 1"></td>
                  <td v-if="bl.presence === 1">{{ bl.HR }}</td>
                  <td v-else-if="bl.presence === 0"></td>
                  <td v-if="bl.presence === 1">{{ bl.Temp }}</td>
                  <td v-else-if="bl.presence === 0"></td>
                  <td v-if="bl.presence === 1">{{ bl.Step }}</td>
                  <td v-else-if="bl.presence === 0"></td>
                  <td v-if="bl.presence === 1">{{ bl.Loc }}</td>
                  <td v-else-if="bl.presence === 0"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

// firebase
import firebase from "../firebase.js";
var auth = firebase.auth();
var db = firebase.database();

export default {
  name: "RealTimeStatus",
  data() {
    return {
      items: [
        {
          name: "xxx xxx",
          id: 123456789,
          entry: "8:50",
          exit: "",
          heartrate: "76",
          bodytemp: "36.3",
          steps: "3776",
          loc: "xxx xxx",
        },
        {
          name: "yyy yyy",
          id: 123456789,
          entry: "8:50",
          exit: "",
          heartrate: "76",
          bodytemp: "36.3",
          steps: "3776",
          loc: "xxx xxx",
        },
      ],
      mapLocLocal: [],
      realTimeLocal: [],
      totalPresent: 0,
      totalAbsent: 0,
    };
  },
  components: {},
  created: function () {
    this.mapLoc();
    this.realTime();
  },
  methods: {
    mapLoc: function () {
      auth.onAuthStateChanged((user) => {
        if (user) {
          var mapLocRef = db.ref("map-location");
          mapLocRef.on("value", (snapshot) => {
            var mapLoc = snapshot.val();
            console.log(mapLoc);
            this.mapLocLocal = [];
            for (var x in mapLoc) {
              this.mapLocLocal.push({
                room: x,
                number: mapLoc[x].length,
              });
            }

            // mark presence
            document.getElementById("marker-present-room1").style.display =
              "none";
            document.getElementById("marker-present-room2").style.display =
              "none";
            document.getElementById("marker-present-room3").style.display =
              "none";
            document.getElementById("marker-present-room4").style.display =
              "none";
            document.getElementById("marker-present-room5").style.display =
              "none";
            document.getElementById(
              "marker-present-meeting-room"
            ).style.display = "none";
            document.getElementById(
              "marker-present-control-room"
            ).style.display = "none";
            this.mapLocLocal.forEach((item) => {
              console.log(item.room);
              if (item.number > 0) {
                document.getElementById(
                  "marker-present-" + item.room
                ).style.display = "block";
              }
            });
          });
        }
      });
    },
    realTime: function () {
      auth.onAuthStateChanged((user) => {
        if (user) {
          var realTimeRef = db.ref("realtime-status");
          realTimeRef.on("value", (snapshot) => {
            var realTime = snapshot.val();
            // console.log(realTime);
            this.realTimeLocal = [];
            for (var x in realTime) {
              this.realTimeLocal.push(realTime[x]);
            }
            console.log(this.realTimeLocal);

            this.realTimeLocal.sort(function (a, b) {
              return b.presence - a.presence;
            });

            // total
            this.totalPresent = 0;
            this.realTimeLocal.forEach((item) => {
              if (item.presence === 1) {
                this.totalPresent += 1;
              }
            });
            this.totalAbsent = this.realTimeLocal.length - this.totalPresent;
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.floor-plan-box {
  width: auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

.floor-plan-box img {
  display: block;
}

.floor-plan-box .floor-plan {
  width: 100%;
  height: auto;
}

/* room 1 marker */
#marker-present-room1 {
  position: absolute;
  top: 13%;
  left: 7%;
  width: 5%;
  display: none;
}

/* room 2 marker */
#marker-present-room2 {
  position: absolute;
  top: 41%;
  left: 57%;
  width: 5%;
  display: none;
}

/* room 3 marker */
#marker-present-room3 {
  position: absolute;
  top: 10%;
  left: 66%;
  width: 5%;
  display: none;
}

/* room 4 marker */
#marker-present-room4 {
  position: absolute;
  top: 10%;
  left: 51.5%;
  width: 5%;
  display: none;
}

/* room 5 marker */
#marker-present-room5 {
  position: absolute;
  top: 10%;
  left: 37.5%;
  width: 5%;
  display: none;
}

/* meeting room marker */
#marker-present-meeting-room {
  position: absolute;
  top: 41%;
  left: 40%;
  width: 5%;
  display: none;
}

/* meeting room marker */
#marker-present-control-room {
  position: absolute;
  top: 21%;
  left: 84%;
  width: 5%;
  display: none;
}
</style>
